<bom-spinner [message]="'HenterKvittering' | tekstresource"></bom-spinner>
